'use strict';

var privatePropertyAccessor = require('../internal/privatePropertyAccessor');

module.exports = privatePropertyAccessor('utc');


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/common/var/_utc.js
// module id = 47
// module chunks = 1